import React from 'react';
import PropTypes from 'prop-types';
import {Icon, notification, Upload} from "antd";
import Auth from '../services/auth';
import {getImageSource} from "../utils/images";

import "./UploadProductImage.css";

class UploadProductImage extends React.Component {
  constructor(props) {
    super(props);
    const {value: imageSrc} = props;
    this.state = {imageSrc};
    this.auth = Auth.getInstance();
  }

  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      const {value: imageSrc} = nextProps;
      this.setState({imageSrc});
    }
  }

  static beforeUpload(file) {
    const errors = [];
    if (!/^image\/(jpeg|png)$/.test(file.type)) {
      errors.push('You can only upload JPEG or PNG');
    }
    if (file.size > 256 * 1024) {
      errors.push('Image must be smaller than 256KB');
    }
    if (errors.length) {
      notification.error({
        message: 'Upload failed',
        description: errors.join('. ')
      });
    }
    return errors.length === 0;
  }

  onChange = info => {
    switch (info.file.status) {
      case 'uploading': {
        this.setState({uploading: true});
        break;
      }
      case 'done': {
        const {imageUri} = info.file.response;
        const state = {uploading: false};
        if (!('value' in this.props)) {
          state.value = imageUri;
        }
        this.setState(state);
        const {onChange} = this.props;
        if (onChange) {
          onChange(imageUri);
        }
        break;
      }
      case 'error': {
        this.setState({uploading: false});
        notification.error({
          message: 'Upload failed',
          description: info.file.response.message
        });
        break;
      }
      default:
        console.log(info);
    }
  };

  render() {
    const {imageSrc, uploading} = this.state;
    const uploadButton = (
      <div>
        <Icon type={uploading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    let headers;
    if (this.auth.isAuthenticated()) {
      const accessToken = this.auth.getAccessToken();
      headers = {
        'Authorization': 'Bearer ' + accessToken,
      };
    }
    return (
      <React.Fragment>
        <div>JPG or PNG. Max 256 KB.</div>
        <Upload
          name="productImage"
          listType="picture-card"
          className="product-image-uploader"
          showUploadList={false}
          action={`${process.env.PUBLIC_URL}/api/v1/product/uploadImage`}
          beforeUpload={UploadProductImage.beforeUpload}
          onChange={this.onChange}
          headers={headers}
        >
          {imageSrc ? <img src={getImageSource(imageSrc)} alt="" /> : uploadButton}
        </Upload>
      </React.Fragment>
    );
  }
}

UploadProductImage.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default UploadProductImage;



// WEBPACK FOOTER //
// ./src/Product/UploadProductImage.js